<template>
	<div class="card">
		<div class="card-header bg-dark">
			<h3 class="mb-0 text-white">
				รายการรับโบนัส
				<small class="ml-1">({{ data.length | format(0) }} ครั้ง)</small>
			</h3>
		</div>

		<el-table row-key="id" header-row-class-name="thead-light" :data="queriedData">
			<el-table-column label="สมาชิก" min-width="150px">
				<div slot-scope="{ row }">
					<router-link :to="`/dashboard/members?search=${row.member.phone}`">
						{{ row.member.firstName }} {{ row.member.lastName }}
					</router-link>
					<br />
					{{ row.member.phone }}
				</div>
			</el-table-column>
			<el-table-column label="โบนัส" min-width="200px">
				<div slot-scope="{ row }">
					{{ row.promotion.name }}
				</div>
			</el-table-column>
			<el-table-column label="จำนวน" min-width="200px">
				<div slot-scope="{ row }">
					{{ row.amount | format }}
				</div>
			</el-table-column>
			<el-table-column label="ยอดเทิร์น" min-width="200px">
				<div slot-scope="{ row }">
					{{ row.totalTurn | format }}
				</div>
			</el-table-column>
			<el-table-column label="วันที่รับโบนัส" min-width="200px">
				<div slot-scope="{ row }">
					{{ row.createdAt | moment('DD/MM/YYYY HH:mm:ss') }}
				</div>
			</el-table-column>
		</el-table>

		<div class="card-footer border-0 d-flex justify-content-between">
			<p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>

			<base-pagination :per-page="pagination.perPage" :total="total" v-model="pagination.currentPage" />
		</div>
	</div>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui'
import { BasePagination } from '../../components'

import moment from 'moment'
import BonusService from '../../services/bonus.service'
import tablePagination from '../../mixins/tablePagination'

export default {
	props: ['data'],
	mixins: [tablePagination([], 10)],
	components: {
		BasePagination,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn,
	},
	created() {
		this.updateTableData(this.data)
	},
	watch: {
		data(v) {
			this.updateTableData(v)
		},
	},
}
</script>
